"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ProjectStatisticsComponent = /** @class */ (function () {
    function ProjectStatisticsComponent() {
        this.gap = 'px';
    }
    return ProjectStatisticsComponent;
}());
exports.ProjectStatisticsComponent = ProjectStatisticsComponent;
